// File for logic corresponding to subheader component
import Subheader from './subheader';

const subheaderConfig = {
  name: 'Subheader',
  class: Subheader,
};

export default subheaderConfig;
